/** Legacy inline `<!-- zw-c:id -->` comment markers (pre-`.zwdoc`; read-only). */

const MARKER_STRIP_RE = /<!--\s*\/?zw-c:[A-Za-z0-9_-]+\s*-->/g;

export function stripAllCommentMarkers(lineText: string): string {
  return lineText.replace(MARKER_STRIP_RE, "").replace(/\s+$/, "");
}
